import React, { useState, useEffect } from 'react';
import { Switch, Spin } from 'antd';
import { toast } from 'react-toastify';
import moment from 'moment';
import apiService from '../services/apiService';
import '../styles/ConfigView.css';

const CONFIG_META = {
  auto_geocoding_enabled: {
    label: 'Actualización automática de coordenadas',
    description: 'Geocodifica por dirección las órdenes del día y las direcciones sin coordenadas al cargar cada vista. Desactivar para evitar resultados incorrectos.',
  },
};

const ConfigView = () => {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    setLoading(true);
    try {
      const data = await apiService.getConfig();
      setConfigs(data);
    } catch (err) {
      toast.error('Error al cargar configuración');
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (key, checked) => {
    setSaving(key);
    try {
      const updated = await apiService.updateConfig(key, checked ? 'true' : 'false');
      setConfigs(prev => prev.map(c => c.key === key ? updated : c));
      toast.success('Configuración guardada');
    } catch (err) {
      toast.error('Error al guardar configuración');
    } finally {
      setSaving(null);
    }
  };

  if (loading) {
    return (
      <div className="config-loading">
        <Spin size="large" />
        <span>Cargando configuración...</span>
      </div>
    );
  }

  return (
    <div className="config-view">
      <div className="config-header">
        <h2>⚙️ Configuración</h2>
        <p>Administra el comportamiento del sistema de rutas de entrega.</p>
      </div>

      {configs.map(cfg => {
        const meta = CONFIG_META[cfg.key] || { label: cfg.key, description: cfg.description };
        const isOn = cfg.value === 'true';
        return (
          <div key={cfg.key} className="config-card">
            <div className="config-card-body">
              <div className="config-card-info">
                <div className="config-card-label">{meta.label}</div>
                <div className="config-card-description">{meta.description}</div>
                <div className="config-card-meta">
                  {cfg.updated_at
                    ? '🕐 Modificado: ' + moment(cfg.updated_at).format('DD/MM/YYYY HH:mm')
                    : 'Sin modificaciones previas'}
                </div>
              </div>

              <div className="config-toggle-area">
                <span className={'config-status-badge ' + (isOn ? 'on' : 'off')}>
                  <span className="config-status-dot" />
                  {isOn ? 'Activo' : 'Inactivo'}
                </span>
                <Switch
                  checked={isOn}
                  loading={saving === cfg.key}
                  onChange={checked => handleToggle(cfg.key, checked)}
                  checkedChildren="ON"
                  unCheckedChildren="OFF"
                  style={{ minWidth: 60 }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ConfigView;
